import {
  getCXPTheme,
  type CXPTheme,
} from "@ops-gsic/cxp-component-library-react";

const baseTheme = getCXPTheme("light");

/**
 * This is to showcase how to create a custom theme based on the CXP light theme.
   You can customize colors, typography, spacing, etc. as needed.
   Generally, it's recommended to stick close to the base theme to ensure consistency
   with the Ontario Design System (ODS) unless specific customizations are required.
   If you do not need customizations, you can directly use the base theme via getCXPTheme("light") or 
   by not specifying a theme in the CXPThemeProvider, which defaults to the light theme.
 */
export const cxpTheme: CXPTheme = {
  name: "cxp-custom-light",
  color: {
    ...baseTheme.color,
    // customize colors as needed
    // btnPrimary: "#005ea5",
    // btnPrimaryHover: "#004a82",
    // btnPrimaryActive: "#003766",
    // link: "#005ea5",
    // linkHover: "#004a82",
    // calloutInfoBG: "#e6f0ff",
    // background: "#f8fafc",
    // textPrimary: "#0f172a",
    // border: "#d0d5dd",
  },
  spacing: {
    ...baseTheme.spacing,
  },
  typography: {
    ...baseTheme.typography,
    // customize typography as needed, generally stick to the base
    // font families and sizes as they align with ODS specs
  },
  breakpoints: {
    ...baseTheme.breakpoints,
  },
  orientation: {
    ...baseTheme.orientation,
  },
  global: {
    ...baseTheme.global,
  },
  grid: {
    ...baseTheme.grid,
  },
  zIndex: {
    ...baseTheme.zIndex,
  },
};
